import {Pagination} from '@store/common/pagination.model';
import {GlobalStatus} from '@store/common/globalStatus.enum';
import {TableFilter, TableFilterType} from '@store/common/tableFilter.model';
import {ManageContact} from '@store/common/organisation.model';
import {ContactType} from '@store/common/organisation.enums';

export interface ClientsUnitsFilters {
  search: string;
  tableFilters: TableFilter[];
}

export namespace ClientsUnitsFilters {
  export const initTableFilters = (clientId?: string) => TableFilterType.initTableFilters([
    TableFilterType.CLIENT_ORGANISATION,
    TableFilterType.ORGANISATION_TYPOLOGY,
    TableFilterType.ORGANISATION_DOMAIN,
  ]).map((f) => ({
    ...f,
    hide: (!!clientId && f.type === TableFilterType.CLIENT_ORGANISATION),
    values: (f.type === TableFilterType.CLIENT_ORGANISATION && !!clientId) ? [{label: '', value: clientId}] : [],
  }));
}

export interface ClientsUnitsPagination extends Pagination {
  data: ClientsUnit[];
}

export interface ClientsUnitUI {
  id: number;
  selected: boolean;
}

export interface ClientsUnit {
  id: number;
  status: GlobalStatus;
  name: string;
  organisationName: string;
  city: string;
  phone: string;
  email: string;
  country: string;
  street: string;
  zip: string;
  region: string;
  clientOrganisationUnitContacts?: ManageContact[];
  unitManagers: any[];
  contactCount: number;
  contactName: string;
  contactRole: ContactType;
  invoicingAdditionalInformation: string;
}
